module.exports = __webpack_public_path__ + "assets/images/template/project/animals/desktop.svg?v=663edfcf";